module.exports = __webpack_public_path__ + "img/Schminke.8b1719c6.jpg";